var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 154.685,
    height: 36.301,
    viewBox: "0 0 154.685 36.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.148,
    y1: 0.852,
    x2: 0.839,
    y2: 0.161,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#5c0cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2979ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1fcbff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-206.125 -136.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(343.239 160.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M871.13,256.59a4.568,4.568,0,0,0-.421,1.9,4.449,4.449,0,0,0,.4,1.922,3.824,3.824,0,0,0,1.207,1.483l-.386.544a4.077,4.077,0,0,1-1.466-1.677,5.079,5.079,0,0,1-.509-2.238,4.979,4.979,0,0,1,.513-2.216,4.217,4.217,0,0,1,1.479-1.69l.369.509A3.739,3.739,0,0,0,871.13,256.59Z",
    transform: "translate(-869.954 -254.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M886.7,258.87h2.238a3.478,3.478,0,0,1,1.361.254,2.566,2.566,0,0,1,.974.685,3.091,3.091,0,0,1,.562.961,3.225,3.225,0,0,1,.193,1.11,3.607,3.607,0,0,1-.184,1.154,3.214,3.214,0,0,1-.549,1,2.526,2.526,0,0,1-.974.72,3.409,3.409,0,0,1-1.383.268H886.7V258.87Zm3.972,4.683a2.532,2.532,0,0,0,.592-1.681,2.294,2.294,0,0,0-.606-1.6,2.2,2.2,0,0,0-1.72-.667H887.46v4.652h1.474A2.134,2.134,0,0,0,890.668,263.553Z",
    transform: "translate(-883.238 -257.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M918.564,258.912h4.319v.7h-3.564v1.922h3.414v.711h-3.414v2.08h3.7v.729h-4.459Z",
    transform: "translate(-908.524 -258.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M943.96,254.544a4.152,4.152,0,0,1,1.479,1.681,4.96,4.96,0,0,1,.513,2.208,5.082,5.082,0,0,1-.509,2.238,4.077,4.077,0,0,1-1.466,1.676l-.378-.553a3.8,3.8,0,0,0,1.2-1.479,4.457,4.457,0,0,0,.395-1.918,4.565,4.565,0,0,0-.421-1.9,3.737,3.737,0,0,0-1.185-1.461l.369-.5Z",
    transform: "translate(-928.381 -254.535)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(206.125 136.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M224.273,136.2a18.15,18.15,0,1,0,18.152,18.152A18.151,18.151,0,0,0,224.273,136.2Zm9.658,22.536a10.868,10.868,0,0,1-1.521,3.251,8.062,8.062,0,0,1-2.033,2.023,8.162,8.162,0,0,1-2.665,1.12,14.946,14.946,0,0,1-3.586.38h-7.6a.459.459,0,0,1-.457-.457V152.474a1.316,1.316,0,0,1,1.315-1.315h.321a1.317,1.317,0,0,1,1.318,1.315v10.279a.117.117,0,0,0,.115.119h4.65a11.509,11.509,0,0,0,3.464-.412,4.96,4.96,0,0,0,2.006-1.158,7.021,7.021,0,0,0,1.632-2.825,13.672,13.672,0,0,0,.589-4.3,10.383,10.383,0,0,0-1.151-5.382,5.794,5.794,0,0,0-2.794-2.518,11.483,11.483,0,0,0-3.823-.457h-6.327a1.322,1.322,0,0,1-1.315-1.318,1.316,1.316,0,0,1,1.315-1.315h6.373a18.728,18.728,0,0,1,3.977.317,7.623,7.623,0,0,1,3.275,1.6,9.131,9.131,0,0,1,2.641,3.816,14.932,14.932,0,0,1,.876,5.305A15.5,15.5,0,0,1,233.932,158.731Zm-17.859-10.244a1.493,1.493,0,1,1,1.493,1.493A1.493,1.493,0,0,1,216.073,148.487Z",
    transform: "translate(-206.125 -136.195)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(250.84 144.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M434.1,184.307c.055,3.253-1.93,6.544-6.434,6.544h-5.055V177.984h5.055C432.075,177.984,434.042,181.127,434.1,184.307Zm-9.081,4.209h2.647a4.119,4.119,0,0,0,0-8.235h-2.647Z",
    transform: "translate(-422.608 -177.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M489.115,195.554h2.151v9.062h-2.114l-.11-1.324a3.443,3.443,0,0,1-2.941,1.6c-2.684.019-4.669-1.636-4.669-4.816a4.412,4.412,0,0,1,4.724-4.743,3.326,3.326,0,0,1,2.886,1.47Zm-5.441,4.522a2.6,2.6,0,0,0,2.684,2.757c3.529,0,3.529-5.5,0-5.5A2.581,2.581,0,0,0,483.674,200.076Z",
    transform: "translate(-469.282 -191.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M535.984,208.478V195.629h2.1l.147,1.25a3.6,3.6,0,0,1,2.941-1.452,4.533,4.533,0,0,1,4.65,4.743,4.422,4.422,0,0,1-4.577,4.742,3.651,3.651,0,0,1-3.014-1.287v4.853Zm7.592-8.308a2.574,2.574,0,0,0-5.147,0,2.574,2.574,0,0,0,5.147,0Z",
    transform: "translate(-512.566 -191.765)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M589.38,208.478V195.629h2.1l.147,1.25a3.6,3.6,0,0,1,2.941-1.452,4.533,4.533,0,0,1,4.65,4.743,4.422,4.422,0,0,1-4.577,4.742,3.651,3.651,0,0,1-3.015-1.287v4.853Zm7.592-8.308a2.573,2.573,0,1,0-5.147,0,2.573,2.573,0,1,0,5.147,0Z",
    transform: "translate(-554.933 -191.765)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M650.159,200.24a4.715,4.715,0,1,1-4.742-4.724A4.581,4.581,0,0,1,650.159,200.24Zm-7.187,0a2.471,2.471,0,1,0,4.927,0,2.559,2.559,0,0,0-2.463-2.684,2.49,2.49,0,0,0-2.464,2.684Z",
    transform: "translate(-595.676 -191.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M697.662,204.837v-4.853c0-1.195-.625-2.279-1.857-2.279a2.068,2.068,0,0,0-1.93,2.279v4.852h-2.243v-9.08h2.077l.165,1.1a2.625,2.625,0,0,1,2.39-1.249,2.715,2.715,0,0,1,2.683,1.691,3.282,3.282,0,0,1,3.033-1.654c2.573,0,3.841,1.581,3.841,4.3v4.889h-2.242v-4.891c0-1.194-.5-2.206-1.71-2.206a2.063,2.063,0,0,0-1.967,2.243v4.852Z",
    transform: "translate(-636.065 -191.911)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M774.428,195.554h2.15v9.062h-2.114l-.11-1.324a3.443,3.443,0,0,1-2.941,1.6c-2.684.019-4.669-1.636-4.669-4.816a4.412,4.412,0,0,1,4.724-4.743,3.326,3.326,0,0,1,2.886,1.47Zm-5.441,4.522a2.6,2.6,0,0,0,2.684,2.757c3.529,0,3.529-5.5,0-5.5A2.58,2.58,0,0,0,768.987,200.076Z",
    transform: "translate(-695.663 -191.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M819.62,184.037v2.573h2.5v1.93H819.6v3.915a1.126,1.126,0,0,0,1.176,1.287,2.567,2.567,0,0,0,1.084-.276l.625,1.911a5.007,5.007,0,0,1-1.856.386c-1.967.074-3.253-1.048-3.253-3.309V188.54h-1.691v-1.93h1.691v-2.334Z",
    transform: "translate(-734.495 -182.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M854.377,179.006a1.324,1.324,0,0,1-2.647,0A1.324,1.324,0,0,1,854.377,179.006Zm-2.445,2.518v9.1h2.242v-9.1Z",
    transform: "translate(-763.095 -177.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M876.862,203.313a4.662,4.662,0,0,1-3.492,1.434,4.8,4.8,0,1,1,0-9.6,4.3,4.3,0,0,1,3.272,1.342l-1.417,1.489a2.752,2.752,0,0,0-1.82-.717,2.55,2.55,0,0,0-2.61,2.684,2.469,2.469,0,0,0,2.573,2.647,2.726,2.726,0,0,0,1.985-.754Z",
    transform: "translate(-776.444 -191.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M915.368,197.83a3.057,3.057,0,0,0-2.242-.809c-1.066,0-1.654.331-1.654.9,0,.588.533.919,1.691.992,1.709.11,3.878.5,3.878,2.9,0,1.6-1.3,2.978-3.9,2.978a5.3,5.3,0,0,1-4.191-1.618l1.1-1.6a4.971,4.971,0,0,0,3.125,1.268c.845.019,1.636-.423,1.636-1.084,0-.625-.515-.883-1.8-.956-1.71-.128-3.75-.754-3.75-2.812,0-2.1,2.169-2.831,3.823-2.831a4.864,4.864,0,0,1,3.529,1.195Z",
    transform: "translate(-808.498 -191.558)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b3bdf917e5016385decac33e4d26095b.svg";
export { ForwardRef as ReactComponent };